<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import TransportationInsuranceData from '@/data/company-page-data/groupama-sigorta/cross-pages/TransportationInsurance'
export default {
  metaInfo: {
    title: 'Groupama Sigorta Nakliyat Sigortası Hesaplama',
    meta: [
      {
        name: 'description',
        content: 'Groupama Sigorta nakliyat sigortası fiyatı için nakliyat sigortası hesaplaması yapın, en uygun poliçe ile taşıma aracı ile yapılacak riskleri güvence altına alın.'
      }
    ]
  },
  name: 'GroupamaSigortaTransportation',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: TransportationInsuranceData.headerContent,
      crossPageContent: TransportationInsuranceData.crossPageContent,
      faqTitle: TransportationInsuranceData.faqTitle,
      faqTitleDesc: TransportationInsuranceData.faqTitleDesc,
      getPrice: TransportationInsuranceData.getPrice
    }
  }
}
</script>
